document.addEventListener("DOMContentLoaded", function () {

    // Run only on this product
    if (document.body.getAttribute("body_id") !== "product-8944928653468") {
         return;
    }

    var shp_priceElement = document.querySelector('[price_id="sopifyProductprice"]');
    var shp_qtyInput = document.querySelector(".product-quantity__selector");

    if (!shp_priceElement || !shp_qtyInput) {
        return;
    }

    var shp_regularPrice = shp_priceElement.textContent.trim();

    var shp_unitPrice = 0;
    var shp_currency = "$";

    function shp_setUnitPrice() {

        var shp_priceText = shp_priceElement.textContent.trim();

        shp_currency = shp_priceText.replace(/[0-9.,\s]/g, "");

        shp_unitPrice = parseFloat(
            shp_priceText.replace(/[^0-9.]/g, "")
        );

        if (isNaN(shp_unitPrice)) {
            shp_unitPrice = 0;
        }
    }

    function shp_calculateTotal() {

        var shp_qty = parseInt(shp_qtyInput.value, 10);

        if (isNaN(shp_qty) || shp_qty < 1) {
            shp_qty = 1;
            shp_qtyInput.value = 1;
        }

        shp_priceElement.textContent =
            shp_currency + (shp_unitPrice * shp_qty).toFixed(2);
    }

    function shp_updatePurchasePrice() {

        var shp_checked = document.querySelector('input[name="bsub-selling-plan-group"]:checked');

        if (!shp_checked) return;

        // One-time Purchase
        if (shp_checked.value === "once") {

            shp_priceElement.textContent = shp_regularPrice;

        } else {

            // Subscribe & Save
            var shp_subPrice = document.querySelector("[data-bsub-per-delivery-price]");

            if (shp_subPrice) {
                shp_priceElement.textContent = shp_subPrice.textContent.trim();
            }
        }

        // Save current unit price
        shp_setUnitPrice();

        // Reset quantity
        shp_qtyInput.value = 1;

        // Refresh total
        shp_calculateTotal();
    }

    // Initial unit price
    shp_setUnitPrice();

    // Quantity typing
    shp_qtyInput.addEventListener("input", shp_calculateTotal);
    shp_qtyInput.addEventListener("change", shp_calculateTotal);

    // Plus / Minus buttons
    document.addEventListener("click", function (e) {

        if (
            e.target.closest(".qty-plus") ||
            e.target.closest(".qty-minus")
        ) {

            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    shp_calculateTotal();
                });
            });

        }

    });

    // Subscription change
    document.addEventListener("change", function (e) {

        if (e.target.name === "bsub-selling-plan-group") {

            setTimeout(function () {
                shp_updatePurchasePrice();
            }, 200);

        }

    });

    // If quantity changes by any other script
    var shp_observer = new MutationObserver(function () {
        shp_calculateTotal();
    });

    shp_observer.observe(shp_qtyInput, {
        attributes: true,
        attributeFilter: ["value"]
    });

    // Initial load
    setTimeout(function () {
        shp_updatePurchasePrice();
    }, 500);

});